<script>
import forms from '@/mixins/forms'

export default {
  name: 'VstupiIndex',
  mixins: [forms],
  data() {
    return {
      loading: false,
      phone: '',
      name: '',
    }
  },
  computed: {
    disabled() {
      return this.phone.length !== 10
    },
  },
  methods: {
    onNameChanged() {
      this.name = ''
    },
    async checkPhone() {
      this.loading = true
      try {
        const resp = await this.axios('/v1/vstupi/check', {
          method: 'post',
          data: { phone: this.phone },
        })
        this.loading = false
        if (resp.status !== 200) {
          this.showSnackbar(resp.data.message, 'error')
          return
        }
        this.name = resp.data.name
        this.showSnackbar(resp.data.name, 'success')
      } catch (error) {
        this.loading = false
        this.showSnackbar('Не найдено', 'error')
      }
    },
  },
}
</script>

<template>
  <v-container>
    <v-card elevation="0" max-width="400" class="ma-auto">
      <v-card-text>
        <v-form @submit.prevent="checkPhone">
          <v-text-field
            v-model="phone"
            label="Номер телефона"
            hint="10 цифр номера без дополнительных знаков, пример: 9161112233"
            name="phone"
            type="number"
            hide-spin-buttons
            :rules="[rules.required]"
            @input="onNameChanged"
            class="ma-2 inputPhone"
          ></v-text-field>
          <div class="ma-2">
            <v-chip v-if="name" x-large outlined color="success">{{ name }}</v-chip>
          </div>
          <div class="ma-2">
            <v-btn
              :disabled="disabled"
              :loading="loading"
              color="primary"
              outlined
              @click="checkPhone"
              >Проверить</v-btn
            >
          </div>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<!--<style scoped>-->
<!--.inputPhone >>> input[type='number'] {-->
<!--  -moz-appearance: textfield !important;-->
<!--}-->
<!--.inputPhone >>> input::-webkit-outer-spin-button,-->
<!--.inputPhone >>> input::-webkit-inner-spin-button {-->
<!--  appearance: none !important;-->
<!--  -webkit-appearance: none !important;-->
<!--  -moz-appearance: none !important;-->
<!--}-->
<!--</style>-->
